<template>
  <vf-dialog-layout class-wrapper="!p-0" data-scroll-el="filtersPanel">
    <template v-if="heading" #title>
      {{ heading }}
    </template>
    <filter-display
      v-bind="{ filters, currency }"
      class="sticky top-0 z-1 b-b b-grey-70 bg-white px-4 py-2"
      :max-collapsed-rows="{ sm: 2, md: 2, lg: 2 }"
      @clear="$emit('clear')"
      @remove="$emit('remove', $event)"
    />
    <base-lazy-hydrate v-if="sortOptions?.length && total" when="interaction">
      <vf-accordion class="fw-light" open size="sm" style="border-top: 0" :title="$t.sort">
        <div class="grid gap-4 pb-6 pt-2">
          <vf-radio
            v-for="{ value, label } in sortOptions"
            :key="value"
            :model-value="sortState"
            name="sort"
            :value="value"
            @update:model-value="$emit('sort', $event!)"
          >
            {{ label }}
          </vf-radio>
        </div>
      </vf-accordion>
    </base-lazy-hydrate>
    <base-lazy-hydrate v-for="(filter, code, i) in filters" :key="`mobileFilter-${code}`" when="interaction">
      <vf-accordion
        class="fw-light"
        data-scroll-el="filtersPanelAccordion"
        :open="i === 0"
        size="sm"
        :title="filter.label"
      >
        <filter-options
          class="pb-6 pt-2"
          :currency
          :filter
          :loading
          :model-value="filter.selected"
          @update:model-value="$emit('update', { code: `${code}`, selected: $event! })"
        />
      </vf-accordion>
    </base-lazy-hydrate>
    <template #footer>
      <div class="f-col center gap-4">
        <vf-button v-bind="seeResultsCta" :class="brandClasses.seeResultsCta" @click="$emit('resolve')">
          {{ replaceAll($t.seeResults, { total }) }}
        </vf-button>
        <base-button :class="brandClasses.resetCta" @click="$emit('clear')">
          {{ $t.clearAll }}
        </base-button>
      </div>
    </template>
  </vf-dialog-layout>
</template>

<script lang="ts" setup>
import type { SortType } from '#types/config/pages/plp'
import type { FiltersMap } from '#types/filters'

export type Props = {
  heading?: string
  total: number
  currency?: string
  filters: FiltersMap
  sortOptions?: { value: SortType, label: string }[]
  loading?: boolean
  sortState?: string
}
export type Emits = {
  resolve: []
  sort: [payload: string]
  update: [payload: { code: string, selected: string[] }]
  remove: [payload: { code: string, id: string }]
  clear: []
}

defineProps<Props>()
defineEmits<Emits>()

const { brandClasses, seeResultsCta } = useAppConfig().components.dialog.filters
</script>
